import * as ACTION_TYPES from 'actions/actionTypes';
import { MESSAGES_PAGE } from 'store/constants';
import initialState from '../initialState';

export const selectAll = 'selectAll';
export const messageModalJobId = 'messageModalJobId';

export const reducer = (state = initialState[MESSAGES_PAGE], action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_MESSAGE_MODAL_JOB_ID: {
      const nextState = { ...state, [messageModalJobId]: action.payload };
      return nextState;
    }
    case ACTION_TYPES.SELECT_JOB_ID_OF_MESSAGE_THREAD: {
      const nextState = { ...state, ...action.payload };
      return nextState;
    }
    case ACTION_TYPES.SELECT_ALL_MESSAGE_THREADS: {
      const nextValue = !state[selectAll];
      return {
        [selectAll]: nextValue,
      };
    }
    case ACTION_TYPES.CLEAR_MESSAGE_THREAD_SELECTIONS: {
      return initialState[MESSAGES_PAGE];
    }
    default:
      return {
        ...state,
      };
  }
};
